import { Programme } from "./programme";

export interface ICreateMerchantApiData {
  country: string;
  currency?: string;
  email: string;
  industryCode: string | null;
  makeEmailAdmin: boolean;
  merchantReferrerCode: string;
  name: string;
  platform: string;
  companySize: string;
}

export interface IPatchMerchantApiData {
  currency?: string;
  name?: string;
  preferredBasketCode?: string;
  tradingName?: string;
  businessRegistrationType?: string;
  companyRegistrationId?: string;
  stateProvince?: string;
  cityTown?: string;
  addressLine1?: string;
  addressLine2?: string;
  postcodeZip?: string;
  pledgeTaken?: boolean;
}

export interface IAcceptMerchantInvitationApiData {
  email: string;
}

export interface IMerchantConfigMenuItem {
  code: string;
}

export interface IMerchantConfig {
  configuration: {
    menuItems?: IMerchantConfigMenuItem[];
    minimumCo2KgAmountToPayByInvoice: number;
    maximumCo2KgAmountToPayByCard: number
  };
}

export interface IMerchant {
  category: any;
  code: string;
  country: string;
  currency: string;
  email: string;
  id: string;
  industryCode: string;
  name: string;
  platform: string;
  pledgeTaken: boolean;
  referrerMerchantCode: string;
  shortDescription: string;
  thumbnailUrl: string;
  url: string;
  preferredBasketCode: string;
  companySize: string;
  programmes: Programme[] | [];
  tradingName: string;
  businessRegistrationType: string;
  companyRegistrationId: string;
  stateProvince: string;
  cityTown: string;
  addressLine1: string;
  addressLine2: string;
  postcodeZip: string;
  serviceFee?: number | null;
}

export enum ReferrerMerchantType {
  EVENT = 'EVENT',
  PARTNER = 'PARTNER',
}

export interface ReferredMerchantTypeConfig {
  code: string;
  title: string;
}

export interface ReferrerMerchantConfig {
  merchantCode: string;
  referrerMerchantRelationshipType: ReferrerMerchantType;
  signUp: {
    title: string;
  };
}